import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    currentUser: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.currentUser = { ...action.payload };
    },
  },
});

export const { setUser } = userSlice.actions;

export const selectCurrentUser = (state) => state.user.currentUser;

export const selectNtAdministrator = (state) =>
  state.user.currentUser === null
    ? false
    : state.user.currentUser.nt_administrator;
export const selectRoles = (state) =>
  state.user.currentUser === null ? [] : state.user.currentUser.roles;
export const selectDisplayName = (state) =>
  state.user.currentUser === null ? '' : state.user.currentUser.display_name;

export default userSlice.reducer;
